import { Component } from 'react';
import PropTypes from 'prop-types';

class SessionTimer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sessionTimerId: null,
            preSessionTimerId: null,
            preSessionIdle: false,
            sessionIdle: false,
            oldDate: +new Date(),
            lastActive: +new Date(),
            remaining: null,
            pageX: null,
            pageY: null,
            stopped: true
        };

        this.reset = this.reset.bind(this);
        this.stop = this.stop.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
        this.togglePreSessionIdleState = this.togglePreSessionIdleState.bind(this);
        this.toggleSessionIdleState = this.toggleSessionIdleState.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.events.forEach(e => this.props.element.addEventListener(e, this.handleEvent));
    }

    componentDidMount() {
        if (this.props.startOnLoad) this.reset();
    }

    componentWillUnmount() {
        // Clear timeout to prevent delayed state changes
        clearTimeout(this.state.sessionTimerId);
        clearTimeout(this.state.preSessionTimerId);
        // Unbind all events
        this.props.events.forEach(e => this.props.element.removeEventListener(e, this.handleEvent));
    }

    handleEvent(e) {

        if (this.state.stopped) return;
        // Already idle, ignore events
        if (this.state.preSessionIdle && this.state.sessionIdle) return;
        // Mousemove event
        if (e.type === 'mousemove') {
            // if coord are same, it didn't move
            if (e.pageX === this.state.pageX && e.pageY === this.state.pageY)
                return;
            // if coord don't exist how could it move
            if (typeof e.pageX === 'undefined' && typeof e.pageY === 'undefined')
                return;
            // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
            let elapsed = (+new Date()) - this.state.oldDate;
            if (elapsed < 200)
                return;
        }

        this.reset();
        
    }

    togglePreSessionIdleState(){
        // Set the state
        this.setState({
            preSessionIdle: !this.state.preSessionIdle
        });
        // Fire the appropriate action
        if (this.state.preSessionIdle){
            this.props.preSessionTimeoutAction();
        }
    }

    toggleSessionIdleState(){
        // Set the state
        this.setState({
            sessionIdle: !this.state.sessionIdle
        });
        // Fire the appropriate action
        if (this.state.sessionIdle){
            this.props.sessionTimeoutAction();
        }
    }

    reset() {
        // reset timers
        clearTimeout(this.state.sessionTimerId);
        clearTimeout(this.state.preSessionTimerId);

        // reset settings
        this.setState({
            sessionIdle: false,
            preSessionIdle: false,
            oldDate: +new Date(),
            lastActive: this.state.oldDate,
            remaining: null,
            sessionTimerId: setTimeout(this.toggleSessionIdleState, this.props.sessionTimeout),
            preSessionTimerId: setTimeout(this.togglePreSessionIdleState, this.props.preSessionTimeout),
            stopped: false
        });
    }

    stop() {
        clearTimeout(this.state.sessionTimerId);
        clearTimeout(this.state.preSessionTimerId);
        
        this.setState({
            stopped: true
        });
    }

    render() {
        return this.props.children ? this.props.children : null;
    }
}

SessionTimer.propTypes = {
    sessionTimeout: PropTypes.number,
    preSessionTimeout: PropTypes.number,
    events: PropTypes.arrayOf(PropTypes.string),
    sessionTimeoutAction: PropTypes.func,
    preSessionTimeoutAction: PropTypes.func,
    element: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // Element ref to watch activty on
    format: PropTypes.string,
    startOnLoad: PropTypes.bool,
    children: PropTypes.node
};

SessionTimer.defaultProps = {
    sessionTimeout: 1000 * 60 * 20, // 20 minutes
    preSessionTimeout: 1000 * 60 * 19, // 19 minutes
    events: ['mousemove', 'keydown', 'wheel', 'DOMMouseScroll', 'mouseWheel', 'mousedown', 'touchstart', 'touchmove', 'MSPointerDown', 'MSPointerMove'],
    sessionTimeoutAction: () => {},
    preSessionTimeoutAction: () => {},
    element: (typeof window === 'undefined' ? 'undefined' : typeof (window)) === 'object' ? document : {},
    startOnLoad: true
};

export default SessionTimer;